export const setDateOnlyNoon = (date: Date): Date => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);
};

export const isSameLocalDay = (a: Date, b: Date): boolean => {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
};

const TIME_RE = /^([01]\d|2[0-3]):([0-5]\d)$/;

export const isValidTimeHHmm = (value: string): boolean => TIME_RE.test(value);

export const combineDateAndTime = (date: Date, timeHHmm: string): Date | null => {
  const match = TIME_RE.exec(timeHHmm.trim());
  if (!match) return null;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes, 0, 0);
};

export const getLocalDayBounds = (day: Date): { start: Date; end: Date } => {
  const start = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 0, 0, 0, 0);
  const end = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 23, 59, 59, 999);
  return { start, end };
};

